// Module
var code = "<style include=\"common-transition-styles common-app-styles\"></style> <ns-button id=\"quiq-chat-button\" on-tap=\"startChat\" class$=\"[[chatType]] btn btn-primary\" disabled$=\"[[disabled]]\" href$=\"[[href]]\">[[buttonDisplayName]]</ns-button>";
// Exports
module.exports = code;